'use client'

import { useEffect } from 'react'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  // RUNTEST/chunk recovery: reload once on a stale-deploy ChunkLoadError that
  // reaches the root boundary, fetching the fresh bundle (guarded against loops).
  useEffect(() => {
    const isChunk =
      error?.name === 'ChunkLoadError' ||
      /ChunkLoadError|Loading chunk [\w-]+ failed|Failed to load chunk/i.test(error?.message ?? '')
    if (isChunk && !sessionStorage.getItem('pv-chunk-reload')) {
      sessionStorage.setItem('pv-chunk-reload', '1')
      window.location.reload()
    }
  }, [error])

  return (
    <html lang="en">
      <body>
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '1.5rem',
            textAlign: 'center',
            fontFamily: 'system-ui, -apple-system, sans-serif',
            backgroundColor: '#ffffff',
            color: '#1a1a2e',
          }}
        >
          <h1 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '0.5rem' }}>
            Something went wrong
          </h1>
          <p style={{ fontSize: '0.875rem', color: '#6b7280', marginBottom: '2rem', maxWidth: '28rem' }}>
            A critical error occurred. Please try again or return to the home page.
          </p>
          <div style={{ display: 'flex', gap: '0.75rem' }}>
            <button
              onClick={reset}
              style={{
                padding: '0.625rem 1.25rem',
                fontSize: '0.875rem',
                fontWeight: 500,
                color: '#ffffff',
                backgroundColor: '#6366f1',
                border: 'none',
                borderRadius: '0.5rem',
                cursor: 'pointer',
              }}
            >
              Try again
            </button>
            {/* eslint-disable-next-line @next/next/no-html-link-for-pages -- global-error cannot use next/link as root layout may be broken */}
            <a
              href="/"
              style={{
                padding: '0.625rem 1.25rem',
                fontSize: '0.875rem',
                fontWeight: 500,
                color: '#6b7280',
                textDecoration: 'none',
                borderRadius: '0.5rem',
              }}
            >
              Go home
            </a>
          </div>
          {error.digest && (
            <p style={{ marginTop: '1.5rem', fontSize: '0.75rem', color: '#9ca3af' }}>
              Reference: {error.digest}
            </p>
          )}
        </div>
      </body>
    </html>
  )
}
